import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "permission-page card border-0 shadow-none rounded-3 mb-40" }
const _hoisted_2 = { class: "card-body p-xl-40 p-lg-30 p-20" }
const _hoisted_3 = { class: "permission-header-card" }
const _hoisted_4 = { class: "permission-header-card__badge" }
const _hoisted_5 = { class: "permission-header-card__title" }
const _hoisted_6 = { class: "permission-header-card__text" }
const _hoisted_7 = { class: "row g-4" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "field-group" }
const _hoisted_10 = { class: "field-label" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "field-group" }
const _hoisted_14 = { class: "field-label" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "permission-toolbar" }
const _hoisted_17 = { class: "permission-toolbar__title" }
const _hoisted_18 = { class: "permission-toolbar__hint" }
const _hoisted_19 = {
  class: "permission-toggle",
  for: "select_all"
}
const _hoisted_20 = ["checked"]
const _hoisted_21 = { class: "row g-4" }
const _hoisted_22 = { class: "permission-card" }
const _hoisted_23 = { class: "permission-card__header" }
const _hoisted_24 = { class: "permission-card__body" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id", "onUpdate:modelValue"]
const _hoisted_27 = { class: "mt-4 pt-2" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ri-shield-keyhole-line" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("group_permission_page.edit_badge")), 1)
        ]),
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("group_permission_page.edit_title")), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("group_permission_page.edit_description")), 1)
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("group_permission_page.role_name")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.role.role_name) = $event)),
                type: "text",
                class: "field-input",
                placeholder: _ctx.$t('group_permission_page.role_name_placeholder'),
                required: ""
              }, null, 8, _hoisted_11), [
                [_vModelText, _ctx.role.role_name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("group_permission_page.description_label")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.role.description) = $event)),
                type: "text",
                class: "field-input",
                placeholder: _ctx.$t('group_permission_page.description_placeholder')
              }, null, 8, _hoisted_15), [
                [_vModelText, _ctx.role.description]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", null, [
            _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.$t("group_permission_page.permission_access")), 1),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("group_permission_page.permission_access_hint")), 1)
          ]),
          _createElementVNode("label", _hoisted_19, [
            _createElementVNode("input", {
              id: "select_all",
              class: "form-check-input",
              type: "checkbox",
              checked: _ctx.isAllSelected,
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
            }, null, 40, _hoisted_20),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("group_permission_page.select_all_permissions")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localizedPermissionGroups, (group, gIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: gIndex,
              class: "col-xl-4 col-lg-6"
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("h6", null, _toDisplayString(group.name), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.permissions, (perm, pIndex) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: pIndex,
                      class: "permission-item",
                      for: `permission-${gIndex}-${perm.key}`
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        id: `permission-${gIndex}-${perm.key}`,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.role[perm.key]) = $event),
                        class: "form-check-input",
                        type: "checkbox",
                        "true-value": 1,
                        "false-value": 0
                      }, null, 8, _hoisted_26), [
                        [_vModelCheckbox, _ctx.role[perm.key]]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(perm.label), 1)
                    ], 8, _hoisted_25))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            class: "btn style-one",
            type: "submit",
            disabled: _ctx.isSubmitting
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-save-3-line" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? _ctx.$t("group_permission_page.updating") : _ctx.$t("group_permission_page.update_role")), 1)
          ], 8, _hoisted_28)
        ])
      ], 32)
    ])
  ]))
}